(function($) {
    'use strict';
    $(document).ready(function() {
        init_popup();

        $('.js-mfp-close').on('click', function() {
            if ($.magnificPopup.instance.isOpen) {
                $.magnificPopup.close();
            }
        });
    });

    function init_popup() {
        var autolinkElements =
                '.js-mfp, a[href$=jpg], a[href$=png], a[href$=gif], a[href$=jpeg], a[href*=".jpg?"], a[href*=".png?"], a[href*=".gif?"], a[href*=".jpeg?"], a[href*="youtube.com/watch"], a[href*="iframe=true"]',
            imageElements = 'a[href$=jpg], a[href$=png], a[href$=gif], a[href$=jpeg], a[href*=".jpg?"], a[href*=".png?"], a[href*=".gif?"], a[href*=".jpeg?"]',
            videoElements = 'a[href*="youtube.com/watch"] , a[href*="iframe=true"]',
            exclude = '.lightbox-added, [data-pswp-width], [data-pswp-height]';

        var videos = $(videoElements)
                .not(exclude)
                .addClass('mfp-iframe'),
            images = $(imageElements)
                .not(exclude)
                .addClass('mfp-image');

        var modalParams = {
            tLoading: '',
            tClose: '',
            fixedContentPos: true,
            removalDelay: 200,
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/watch',
                        id: function(url) {
                            //fetch the id
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/),
                                id,
                                params;
                            if (!m || !m[1]) return null;

                            id = m[1];

                            //fetch params
                            params = url.split('/watch');
                            params = params[1];

                            return id + params;
                        },
                        src: '//www.youtube.com/embed/%id%'
                    }
                }
            },
            callbacks: {
                beforeOpen: function() {
                    if (this.st.el.data('mfp-class')) {
                        $.magnificPopup.instance.contentContainer.addClass(this.st.el.data('mfp-class'));
                    }
                    if (this.st.el.data('mfp-align-top')) {
                        this.st.alignTop = this.st.el.data('mfp-align-top');
                    }
                },
                beforeClose: function() {},
                afterClose: function() {
                    $('.js-submenu')
                        .attr('style', '')
                        .parent()
                        .removeClass('show');
                },
                elementParse: function(item) {
                    if (item.src.indexOf('data-mfp-content') > -1) {
                        console.log('ss');
                        item.content = '';
                        $(item.src).each(function() {
                            item.content += $(this).html();
                        });
                        item.src = '<div class="mfp-inner">' + item.content + '</div>';
                    }
                }
            }
        };

        $(autolinkElements)
            .not(exclude)
            .addClass('lightbox-added')
            .magnificPopup(modalParams);
    }

    var lightbox = new PhotoSwipeLightbox({
        gallery: 'a[data-pswp-width], a[data-pswp-height]',
        // dynamic import is not supported in UMD version
        pswpModule: PhotoSwipe,
        //initialZoomLevel: 1,
        //secondaryZoomLevel: 'fit',
        padding: { top: 40, bottom: 40, left: 40, right: 40 }
    });

    function getCroppedZoomPan(position, min, max) {
        var float = parseFloat(position);

        return position.indexOf('%') > 0 ? min + (max - min) * float / 100 : float;
    }

    function getThumbnail(el) {
        return el.querySelector('img');
    }

    function getObjectPosition(el) {
        return getComputedStyle(el).getPropertyValue('object-position').split(' ');
    }

    /*lightbox.on('initialZoomPan', function (event) {
        /!*var slide = event.slide;
        var position = getObjectPosition(getThumbnail(slide.data.element));

        if (position[0] !== '50%' && slide.pan.x < 0) {
            slide.pan.x = getCroppedZoomPan(position[0], slide.bounds.min.x, slide.bounds.max.x);
        }

        if (position[1] !== '50%' && slide.pan.y < 0) {
            slide.pan.y = getCroppedZoomPan(position[1], slide.bounds.min.y, slide.bounds.max.y);
        }*!/
        event.slide.pan.y = 40;

        return event;
    });*/

    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'custom-caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            html: 'Caption text',
            onInit: function(el, pswp)  {
                lightbox.pswp.on('change', function() {
                    var currSlideElement = lightbox.pswp.currSlide.data.element;
                    var captionHTML = '';

                    if (currSlideElement) {
                        var hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
                        if (hiddenCaption) {
                            // get caption from element with class hidden-caption-content
                            captionHTML = hiddenCaption.innerHTML;
                        } else {

                            // get caption from alt attribute
                            captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                        }
                    }
                    el.innerHTML = captionHTML || '';
                });
            }
        });
    });

    lightbox.init();
})(jQuery);
